// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27yid","tabsBox":"styles_tabsBox__1ayNZ","createButton":"styles_createButton__25mbI"};